/**
 * @desc 新增料耗比
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialConsumptionThanNewParameters,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/web/consumptionRatio/create',
    data,
  });
}

export function mock(
  data: defs.MaterialConsumptionThanNewParameters,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/web/consumptionRatio/create',
    data,
  });
}
